(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peptia-home-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('peptia-story-video')) {
    customElements.define('peptia-story-video',class extends HTMLElement {
      connectedCallback() {
        this.events=new AbortController();
        this.querySelector('[data-play]')?.addEventListener('click',()=>{
          const host=this.querySelector('[data-player-host]');
          if(host.querySelector('video')) return;
          const fragment=this.querySelector('[data-player-template]').content.cloneNode(true);
          const video=fragment.querySelector('video');
          const poster=this.querySelector('[data-play]');
          host.appendChild(fragment);
          poster.remove();
          video.focus({preventScroll:true});
          video.play().catch(()=>{});
        },{signal:this.events.signal});
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peptia-oferta-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('peptia-announcement')) {
    class PeptiaAnnouncement extends HTMLElement {
      connectedCallback() {
        this.hours = this.querySelector('[data-hours]');
        this.minutes = this.querySelector('[data-minutes]');
        this.seconds = this.querySelector('[data-seconds]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.index = 0;
        this.elapsed = 0;
        this.autoplay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.clock = new Intl.DateTimeFormat('en-GB', {timeZone:this.dataset.timezone,hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.querySelector('[data-next]').addEventListener('click', () => { this.autoplay=false; this.nextSlide(); }, options);
        document.addEventListener('visibilitychange', () => this.updateClock(), options);
        this.updateClock();
        this.interval = window.setInterval(() => this.updateClock(),1000);
        this.rotation = window.setInterval(() => {
          if(this.autoplay && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) {
            this.elapsed += 1;
            if(this.elapsed >= (this.index === 0 ? 12 : 6)) this.nextSlide();
          }
        },1000);
      }
      disconnectedCallback() {
        window.clearInterval(this.interval);
        window.clearInterval(this.rotation);
        this.events.abort();
      }
      nextSlide() {
        this.elapsed = 0;
        this.slides[this.index].hidden=true;
        this.index=(this.index+1)%this.slides.length;
        this.slides[this.index].hidden=false;
      }
      updateClock() {
        const parts=Object.fromEntries(this.clock.formatToParts(new Date()).map(part=>[part.type,part.value]));
        const remaining=86400-(Number(parts.hour)*3600+Number(parts.minute)*60+Number(parts.second));
        this.hours.textContent=String(Math.floor(remaining/3600)).padStart(2,'0');
        this.minutes.textContent=String(Math.floor((remaining%3600)/60)).padStart(2,'0');
        this.seconds.textContent=String(remaining%60).padStart(2,'0');
      }
    }
    customElements.define('peptia-announcement',PeptiaAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peptia-protocolo-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('peptia-protocol-carousel')) {
    customElements.define('peptia-protocol-carousel',class extends HTMLElement {
      connectedCallback() {
        this.track=this.querySelector('[data-track]');
        if(!this.track) return;
        this.events=new AbortController();
        this.controls=this.querySelector('[data-controls]');
        this.dots=this.querySelector('[data-dots]');
        this.cards=Array.from(this.track.children);
        this.update=()=>{
          const overflow=this.track.scrollWidth>this.track.clientWidth+2;
          if(this.controls) this.controls.hidden=!overflow;
          if(this.dots) this.dots.hidden=!overflow;
          const box=this.track.getBoundingClientRect();
          const padding=parseFloat(getComputedStyle(this.track).scrollPaddingLeft)||0;
          let index=0,distance=Infinity;
          this.cards.forEach((card,i)=>{ const d=Math.abs(card.getBoundingClientRect().left-box.left-padding); if(d<distance){distance=d;index=i;} });
          this.querySelectorAll('[data-slide]').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
          const prev=this.querySelector('[data-direction="-1"]'),next=this.querySelector('[data-direction="1"]');
          if(prev) prev.disabled=this.track.scrollLeft<2;
          if(next) next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;
          this.active=index;
        };
        const go=index=>{
          const card=this.cards[Math.min(this.cards.length-1,Math.max(0,index))];
          const left=card.getBoundingClientRect().left-this.track.getBoundingClientRect().left+this.track.scrollLeft-(parseFloat(getComputedStyle(this.track).scrollPaddingLeft)||0);
          this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        };
        this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>go(this.active+Number(button.dataset.direction)),{signal:this.events.signal}));
        this.querySelectorAll('[data-slide]').forEach(button=>button.addEventListener('click',()=>go(Number(button.dataset.slide)),{signal:this.events.signal}));
        this.track.addEventListener('scroll',this.update,{passive:true,signal:this.events.signal});
        this.resize=new ResizeObserver(this.update); this.resize.observe(this.track); this.update();
      }
      disconnectedCallback(){this.events?.abort();this.resize?.disconnect();}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
